export default {
    key: 'joch-epr',
    common: {
        productName: 'core.productNames.joch-epr',
        splashMessage: 'offerFlow.splashMessage.joch-epr',
        headingAside: 'offerFlow.headingAside.joch-epr',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.joch',
    },
    stepNumberOfPeople: {
        heading: 'offerFlow.pages.stepNumberOfPeople.heading.common',
        body: 'offerFlow.pages.stepNumberOfPeople.body.common',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.epr.infoModal.heading',
            body: 'offerFlow.pages.stepPassengers.epr.infoModal.body',
        },
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.joch-epr',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.epr.infoModal.heading',
            body: 'offerFlow.pages.stepPassengers.epr.infoModal.body',
        },
    },
} satisfies OfferFlowContent;
